import axios from "axios"
import { useEffect, useMemo, useState } from "react"
import { isMobile } from "../../utils/miscutils"
import { getRedirectToken } from "../../../utils/cookieUtils"
import axiosInstance from "../../../utils/axiosInterceptor"
function getPlatformInfo() {
  let source = "DESKTOP_WEB";
  if (isMobile()) {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("android") == -1) {
      source = "IOS_WEB";
    } else {
      source = "ANDROID_WEB";
    }
  }
  return {
    bookingPlatform: source,
    platform: isMobile() ? "mweb" : "web",
  };
}

const useFetchWidgets = ({pageId, carouselId, enabled}) => {
    const [banners, setBanners] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const platforms = getPlatformInfo();

    const token = getRedirectToken();

    const fetchPageConfiguration = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(`https://www.medibuddy.in/WAPI/pageConfiguration/${pageId}`, {
                headers: {
                    accesstoken: token, 
                    mbaccesstoken: token,
                    "X-CSRFToken": token, 
                    platform: platforms.platform,
                    overrideplatform: platforms.platform,
                    Booking_Platform: platforms.bookingPlatform,
                }
            })
            if (response.status === 200) {
                const subWidgets = response.data.widgets.find(widget => widget.widgetId === carouselId)?.subWidgets;
                subWidgets && setBanners(subWidgets)
            } else {
                console.error("No widgets set for this page")
            }

        } catch (error) {
            console.error(error)
            setError(error);
        } finally {
            setLoading(false)
        }        
    }

    useEffect(() => {
        if (enabled) {
            fetchPageConfiguration()
        }
    }, [pageId, carouselId, enabled])

    return { banners, loading, error }
}


export default useFetchWidgets;